import React, {useState} from 'react';
import axios from 'axios';
import Plot from 'react-plotly.js';
import { Link } from 'react-router-dom';
import {getCookie} from "../../tools/tools";
import {useTranslation} from "react-i18next";
import IndexNavbar from "../../components/Navbars/IndexNavbar";
import {Container} from "reactstrap";
import Footer from "../../components/Footers/IndexFooter";

const Zcalc2 = () => {
    const {t} = useTranslation();
    const [formData, setFormData] = useState({
        diagnostic_point: 'Rectum',
        T1: 25,
        dT1: 0.1,
        T2: 23.9,
        dT2: 0.1,
        Ta: 10,
        dTa: 0.1,
        dt: 1.0841722,
        ddt: 0.0055,
        T0: 37.2,
        dT0: 0.3,
        b: 0.5,
    });

    const names = {
        'T1': 'T1measurement',
        'T2': 'T2measurement',
        'Ta': 'Ta',
        'dt': 'dt',
        'T0': 'T0',
        'b': 'b',
    }

    const [result, setResult] = useState(null);
    const [errors, setErrors] = useState([]);

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setFormData({...formData, [name]: value});
    };

    const handleSubmit = async () => {
        try {
            const response = await axios.post('/api/z-calc/2', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-CSRFToken': getCookie('csrftoken')
                },
                withCredentials: true,
            });
            if (response.data.errors && response.data.errors.length > 0) {
                setErrors(response.data.errors);
                setResult(null);
            } else {
                setResult(response.data);
                console.log(response.data);
                setErrors([]);
            }
        } catch (error) {
            console.error('Error occurred:', error);
            const errors = error.response.data.errors;
            if(errors.length > 0)
                    setErrors(errors);
            else
                setErrors(['An error occurred while processing the request.']);
        }
    };

    const coolingData =
        result && result.cooling
            ? [
                {
                    x: result.cooling.solution.x,
                    y: result.cooling.solution.y,
                    name: t("CoolingCurve"),
                    mode: "lines",
                    line: {color: "blue"},
                },
                {
                    x: result.ambient.x,
                    y: result.ambient.y,
                    name: t("Ta"),
                    mode: "lines",
                    line: {color: "red"},
                },
            ]
            : [];
    return (
        <div className="content">
            <IndexNavbar brandText={t("Simple FEM Calculator")}/>
            <div className="section section-components pt-100">
                <div className="container mb-5 pb-100">
                    <h1 className="h1 text-success font-weight-bold mb-4">Warm Bodies Z 2</h1>
                    <small className="mb-3 text-uppercase font-weight-bold">{t('inputDataParameters')}</small>

                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">{t('diagnosticPoint')}:</label>
                        <div className="col-sm-8">
                            <label style={{display: "flex", alignItems: "center"}}>
                                <input
                                    type="radio"
                                    name="diagnostic_point"
                                    value="Rectum"
                                    checked={formData.diagnostic_point === 'Rectum'}
                                    onChange={handleInputChange}
                                />
                                <span style={{fontSize: 15, paddingLeft: 10}}>{t('Rectum')}</span>
                            </label>
                            <label style={{display: "flex", alignItems: "center"}}>
                                <input
                                    type="radio"
                                    name="diagnostic_point"
                                    value="Brain"
                                    checked={formData.diagnostic_point === 'Brain'}
                                    onChange={handleInputChange}
                                />
                                <span style={{fontSize: 15, paddingLeft: 10}}>{t('Brain')}</span>
                            </label>
                        </div>
                    </div>

                    {/* Input Fields */}
                    {[["T1", "dT1"], ["T2", "dT2"], ["Ta", "dTa"], ["dt", "ddt"], ["T0", "dT0"]].map((fields) => (
                        <div className={"form-group row"}>
                            {/*todo*/}
                            <label className={'col-sm-4 col-form-label'}
                                   htmlFor={fields[0]}>{t(names[fields[0]])}:</label>
                            <input
                                className="col-sm-4 form-control"
                                key={fields[0]}
                                type="number"
                                name={fields[0]}
                                value={formData[fields[0]]}
                                onChange={handleInputChange}
                            />
                            <label className={'col-sm-1 col-form-label'} htmlFor={fields[1]}>+-</label>
                            <input
                                className="col-sm-3 form-control"
                                key={fields[1]}
                                type="number"
                                name={fields[1]}
                                value={formData[fields[1]]}
                                onChange={handleInputChange}
                            />
                        </div>))}

                    <div className={"form-group row"}>
                        <label className={'col-sm-4 col-form-label'} htmlFor={"b"}>{t(names["b"])}:</label>
                        <input
                            className="col-sm-4 form-control"
                            key={"b"}
                            type="number"
                            name={"b"}
                            value={formData["b"]}
                            onChange={handleInputChange}
                        />
                    </div>

                    <button onClick={handleSubmit} className="btn btn-secondary mb-2">
                        {t('Calc')}
                    </button>

                    <div className="mt-2 mb-3">
                        <small className="text-muted">
                            {t('CalculateConsentText')}{' '}
                            <Link to="/agreement">{t('UserAgreementLink')}</Link>
                            {t('CalculateConsentTextAfter')}
                        </small>
                    </div>

                    <br/>

                    {errors.length > 0 && (
                        <div>
                            {errors.map((error, index) => (
                                <div key={index} className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            ))}
                        </div>
                    )}

                    {result && (
                        <div className="alert alert-success" role="alert">
                            <h2 className="text-white">{t('Results')}</h2>
                            <div className="form-group row">
                                <label className="col-sm-6 col-form-label">k:</label>
                                <label className="col-sm-6 col-form-label">{result.k}</label>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-6 col-form-label">p:</label>
                                <label className="col-sm-6 col-form-label">{result.p}</label>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-6 col-form-label">{t('TimeDeath')}:</label>
                                <label className="col-sm-6 col-form-label">{result.t}</label>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-6 col-form-label">{t('MinTimeDeath')}:</label>
                                <label className="col-sm-6 col-form-label">{result.tMin}</label>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-6 col-form-label">{t('MaxTimeDeath')}:</label>
                                <label className="col-sm-6 col-form-label">{result.tMax}</label>
                            </div>
                            <Plot
                                data={coolingData}
                                layout={{
                                    title: {
                                        text: t("CoolingCurve"),
                                        font: {color: '#2A3F5F'}, // Цвет текста заголовка
                                    },
                                    xaxis: {
                                        title: {
                                            text: t("TimeDeath"),
                                            font: {color: '#2A3F5F'}, // Цвет текста по оси X
                                        },
                                        gridcolor: 'white', // Цвет сетки по оси X
                                        linecolor: 'rgba(0,0,0,0)',
                                    },
                                    yaxis: {
                                        title: {
                                            text: t("Temperature"),
                                            font: {color: '#2A3F5F'}, // Цвет текста по оси Y
                                        },
                                        gridcolor: 'white', // Цвет сетки по оси Y
                                        linecolor: 'rgba(0,0,0,0)',
                                    },
                                    plot_bgcolor: '#E5ECF6', // Цвет фона графика
                                    paper_bgcolor: '#FFFFFF', // Цвет фона всей области графика
                                    gridcolor: 'white', // Цвет сетки на фоне графика
                                    linecolor: 'rgba(0,0,0,0)',
                                }}
                                style={{width: "100%", height: "100%"}} // Ширина и высота 100% родителя
                                useResizeHandler={true}  // Позволяет изменять размер при ресайзе окна
                            />
                        </div>
                    )}
                </div>
                {!result && (<div className="section section-components pt-150"></div>)}
                <Container fluid style={{backgroundColor: '#f4f5f7'}}>
                    <Footer/>
                </Container>
            </div>
        </div>
    );
};

export default Zcalc2;
